import api from '@/modules/api'
import { mutationNames } from '@/store/storeKey'
const state = {
  youtube: {
    Id: null,
    PageTitle: null,
    YouTubeChannel: null,
    YouTubeAPIKey: null,
    SubscriptionModule_Id: 0
  }
}
const getters = {
  Youtube: state => state.youtube
}
const mutations = {
  [mutationNames.SET_YOUTUBE] (state, youtube) {
    state.youtube = youtube
  },
  [mutationNames.UPDATE_YOUTUBE] (state, obj) {
    Object.assign(state.youtube, obj)
  }
}
const actions = {
  async UrlValidChk ({ commit, getters }, WebsiteUrl) {
    const response = await api.AppModules.WebsiteUrlValid(WebsiteUrl)
    return response
  },
  updateYoutubeSettings ({ commit, getters }, payload) {
    commit(mutationNames.UPDATE_YOUTUBE, payload)
  },
  async getYoutubeModule ({ commit, getters }, SubscriptionModuleId) {
    const response = await api.AppModules.GetYoutubeInfo(SubscriptionModuleId)
    commit(mutationNames.SET_YOUTUBE, response[0])
  },
  async saveYoutubeSettings ({ dispatch, getters }) {
    let YoutubeClone = Object.assign({}, getters.Youtube)
    await api.AppModules.SaveYoutubeInfo(YoutubeClone)
  },
  async getYoutubeChannel ({ commit, getters }, payload) {
    const response = await api.AppModules.getYoutubeChannel(payload)
    return response
  }

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/appModules/youtube.js